import SearchPickerController from "./search_picker_controller"

export default class extends SearchPickerController {
  static values = { brandId: String, productId: String, groupId: String, groupOnly: Boolean }

  // Product search finds an exact product ID for employees, so pasting one selects it.
  get selectsPastedIds() { return true }

  get searchUrl() {
    // If a custom search URL is provided, use it
    if (this.hasSearchUrlValue) {
      return this.searchUrlValue
    }

    // Build search URL for product version selection (brand + exclude product)
    if (this.hasBrandIdValue && this.hasProductIdValue) {
      return `/search/products_search.json?search[brand_id]=${this.brandIdValue}&search[exclude_product_id]=${this.productIdValue}&search[term]=`
    }

    // Build search URL for product group selection (brand + exclude group)
    if (this.hasBrandIdValue && this.hasGroupIdValue && this.groupOnlyValue) {
      return `/search/products_search.json?search[brand_id]=${this.brandIdValue}&search[group_only]=true&search[exclude_group_id]=${this.groupIdValue}&search[term]=`
    }

    // Default: simple product search
    return '/search/products_search.json?search[term]='
  }
}
